import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../service/udnick';
import { IFilter } from 'store/ducks/movimentacoes/types';

export const MovimentacoesServices = {
  getNotasPrincipal: (
    filtro: IFilter | undefined,
    inscricoesEstaduais: number | undefined,
    centroDistribuicao: number | undefined,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService(
      'getNotasPrincipal',
      {
        filtro,
        inscricoesEstaduais,
        centroDistribuicao,
      },
      { tamanhoPagina }
    ),

  getNotasSecundarias: (
    nuNota: number,
    centroDistribuicao: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getNotasSecundarias', { nuNota, centroDistribuicao }),
};

export const EmissorNotaServices = {
  getEmitentes: (
    inscricoesEstaduais: any,
    centroDistribuicao: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getEmitentes', { inscricoesEstaduais, centroDistribuicao }),
};
